import styled from "@emotion/styled";
import { tablet } from "../../../media";

export const Wrap = styled.div`
    height: 100%;
    display: flex;
    flex-direction: column;
`;

export const StatusBar = styled.div`
    padding: 8px 14px 0;
    font-size: 12px;
    opacity: 0.6;
    font-family: Inter, system-ui, -apple-system, Segoe UI, Roboto, sans-serif;
`;

export const ListWrap = styled.div`
    position: relative;
    width: 100%;
    flex: 1;
    min-height: 0; /* critical: allow inner scroll container to size correctly */
`;

export const List = styled.div`
    width: 100%;
    height: 100%;
    overflow-y: auto;

    padding: 0px 0 12px 0;

    display: flex;
    flex-direction: column;
    gap: 4px;
    box-sizing: border-box;
    scroll-behavior: auto;
    -webkit-overflow-scrolling: touch;

    scrollbar-width: thin;
    scrollbar-color: transparent transparent;
    transition: scrollbar-color 0.3s ease;

    &:hover {
        scrollbar-color: #3a3c44 transparent;
    }

    &::-webkit-scrollbar {
        width: 4px;
    }
    &::-webkit-scrollbar-track {
        background: transparent;
    }
    &::-webkit-scrollbar-thumb {
        background: rgba(58, 60, 68, 0);
        border-radius: 4px;
        transition: background 0.3s ease;
    }
    &:hover::-webkit-scrollbar-thumb {
        background: #3a3c44;
    }
    &:hover::-webkit-scrollbar-thumb:hover {
        background: #4a4c54;
    }

    ${tablet`
        max-width: 720px;
        margin: 0 auto;
        padding-left: 16px;
        padding-right: 16px;
    `}
`;

export const Row = styled.div<{ isMine: boolean }>`
    width: 100%;
    display: flex;
    flex-direction: row;
    gap: 8px;
    justify-content: ${(p) => (p.isMine ? "flex-end" : "flex-start")};
    padding: 12px 0px;
    align-items: flex-start;
`;

/** Avatar column — fixed width: avatar (34px) + 8px gap */
export const AvatarCol = styled.div`
    flex: 0 0 34px;
    display: flex;
    flex-direction: column;
    align-items: center;
`;

/** Content column — fills remaining space next to avatar */
export const ContentCol = styled.div`
    flex: 1;
    min-width: 0;
    display: flex;
    flex-direction: column;
    gap: 12px;
    overflow: hidden;
`;

/** @deprecated kept for compatibility — use AvatarCol + ContentCol */
export const HeaderRow = styled.div`
    width: 100%;
    display: flex;
    align-items: flex-start;
    min-width: 0;
    overflow: hidden;
`;

/** @deprecated */
export const HeaderLeft = styled.div`
    display: flex;
    align-items: flex-start;
    gap: 8px;
    width: 100%;
    min-width: 0;
    max-width: 100%;
    flex: 1;
    overflow: hidden;
`;

/** @deprecated */
export const HeaderRight = styled.div`
    margin-left: auto;
    display: flex;
    align-items: flex-start;
    gap: 8px;
    width: 100%;
    min-width: 0;
    max-width: 100%;
    overflow: hidden;
    justify-content: flex-end;
`;

export const MineMax = styled.div`
    width: calc(100% - 42px);
    display: flex;
    gap: 8px;
    overflow: hidden;
    margin-left: auto;
`;

export const MineConversationWrapper = styled.div`
    display: flex;
    flex: 1;
    min-width: 0;
    padding: 12px;
    background: #23252a;
    border: 1px solid #2b2d33;
    border-radius: 16px;
`;

export const MineText = styled.div`
    min-width: 0;
    display: flex;
    flex: 1;
    flex-direction: column;
    gap: 8px;

    font-family: Inter, system-ui, -apple-system, Segoe UI, Roboto, sans-serif;
    font-weight: 400;
    font-size: 16px;
    line-height: 150%;
    letter-spacing: 0px;
    vertical-align: middle;
    color: #e9ecf5;

    white-space: pre-wrap;
    word-break: break-word;

    a {
        color: #5E84ED;
        text-decoration: underline;
        word-break: break-all;
    }
`;

export const AdminContainer = styled.div`
    display: flex;
    gap: 8px;
    align-items: flex-start;

    flex: 1;
    min-width: 0;
    width: 100%;
`;

export const AdminText = styled.div`
    flex: 1;
    min-width: 0;
    width: 100%;
    // padding: 16px;
    font-family:
        Custora,
        Inter,
        system-ui,
        -apple-system,
        Segoe UI,
        Roboto,
        sans-serif;
    font-weight: 400;
    font-size: 16px;
    line-height: 150%;
    letter-spacing: 0.1px;
    vertical-align: middle;
    color: #e9ecf5;
    white-space: pre-wrap;
    word-break: break-word;

    a {
        color: #5E84ED;
        text-decoration: underline;
        word-break: break-all;
    }
`;

export const AvatarWrap = styled.div`
    width: 28px;
    height: 28px;
    border-radius: 999px;
    overflow: hidden;
    flex: 0 0 28px;

    background: #2b2d33;
    border: 1px solid #2f3138;
    display: grid;
    place-items: center;
`;

export const AvatarImg = styled.img`
    width: 100%;
    height: 100%;
    object-fit: cover;
    display: block;
`;

export const AvatarFallback = styled.div`
    width: 100%;
    height: 100%;
    padding: 12px;
    display: grid;
    place-items: center;

    & > img {
        width: 100%;
        height: 100%;
        object-fit: contain;
        display: block;
    }
`;

export const FileCard = styled.div`
    margin-top: 8px;
    border: 1px solid #2f3138;
    background: #2b2d33;
    padding: 8px;
    border-radius: 12px;

    display: flex;
    gap: 1px;
    align-items: center;

    max-width: 100%;
    overflow: hidden;
`;

export const FileIcon = styled.img`
    width: 32px;
    height: 32px;
    flex: 0 0 20px;
    display: block;
`;

export const FileTextCol = styled.div`
    display: flex;
    flex-direction: column;
    gap: 2px;
    min-width: 0;
    flex: 1;
`;

export const FileName = styled.div`
    font-family: Inter, system-ui, -apple-system, Segoe UI, Roboto, sans-serif;
    font-weight: 500;
    font-size: 14px;
    line-height: 120%;
    letter-spacing: 0px;
    vertical-align: middle;
    color: #e9ecf5;

    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
`;

export const FileMeta = styled.div`
    font-family: Inter, system-ui, -apple-system, Segoe UI, Roboto, sans-serif;
    font-weight: 500;
    font-size: 12px;
    line-height: 120%;
    letter-spacing: 0px;
    vertical-align: middle;
    color: #b7bdcb;

    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
`;

/* ── File preview (images / videos) ── */

export const PreviewWrap = styled.div`
    position: relative;
    margin-top: 8px;
    max-width: 260px;
    border-radius: 10px;
    overflow: hidden;
`;

export const PreviewImg = styled.img`
    display: block;
    width: 100%;
    max-height: 200px;
    object-fit: cover;
    border-radius: 10px;
`;

export const PreviewVideo = styled.video`
    display: block;
    width: 100%;
    max-height: 200px;
    border-radius: 10px;
    background: #000;
`;

export const PreviewShimmer = styled.div`
    width: 100%;
    height: 120px;
    border-radius: 10px;
    background: linear-gradient(
        110deg,
        #2b2d33 0%,
        #33363d 40%,
        #2b2d33 60%
    );
    background-size: 200% 100%;
    animation: shimmer 1.4s ease-in-out infinite;

    @keyframes shimmer {
        0% { background-position: 200% 0; }
        100% { background-position: -200% 0; }
    }
`;

export const DownloadBtn = styled.button`
    position: absolute;
    bottom: 6px;
    right: 6px;

    width: 28px;
    height: 28px;
    border: none;
    border-radius: 8px;
    background: rgba(0, 0, 0, 0.55);
    backdrop-filter: blur(4px);

    display: inline-flex;
    align-items: center;
    justify-content: center;

    cursor: pointer;
    touch-action: manipulation;
    -webkit-tap-highlight-color: transparent;
    transition: background 120ms ease;

    &:active {
        background: rgba(0, 0, 0, 0.75);
    }

    svg {
        width: 16px;
        height: 16px;
        color: #e9ecf5;
    }
`;

export const FileDownloadBtn = styled.button`
    flex-shrink: 0;
    width: 32px;
    height: 32px;
    margin-left: auto;
    border: none;
    border-radius: 8px;
    background: transparent;

    display: inline-flex;
    align-items: center;
    justify-content: center;

    cursor: pointer;
    touch-action: manipulation;
    -webkit-tap-highlight-color: transparent;
    transition: background 120ms ease;

    &:active {
        background: rgba(255, 255, 255, 0.08);
    }

    svg {
        width: 16px;
        height: 16px;
        color: #b7bdcb;
    }
`;

export const DateRow = styled.div`
    display: flex;
    flex-direction: column;
    gap: 6px;
    align-items: flex-end;
    
    font-family: Inter, system-ui, -apple-system, Segoe UI, Roboto, sans-serif;
    font-weight: 400;
    font-size: 12px;
    line-height: 140%;
    letter-spacing: 0px;
    vertical-align: middle;
    color: #b7bdcb;
`;

export const DateAndLabelRow = styled.div`
    display: flex;
    flex-direction: column;
    gap: 6px;
    justify-content: flex-end;

    font-family: Inter, system-ui, -apple-system, Segoe UI, Roboto, sans-serif;
    font-weight: 400;
    font-size: 12px;
    line-height: 140%;
    letter-spacing: 0px;
    vertical-align: middle;
    color: #b7bdcb;
    align-items: flex-end;
`;

export const AdminFooter = styled.div`
    display: flex;
    flex-direction: column;
    gap: 8px;
`;

export const ListenIcon = styled.img`
    width: 16px;
    height: 16px;
    flex: 0 0 16px;
    display: block;
`;

export const SafetyDiv = styled.div`
    padding-bottom: calc(env(safe-area-inset-bottom, 0px) + 150px);
`;

export const SentViaSmsLabel = styled.span`
    font-family: Inter, system-ui, -apple-system, Segoe UI, Roboto, sans-serif;
    font-weight: 400;
    font-size: 12px;
    line-height: 140%;
        color: #5E84ED;
    font-size: 12px;
`;

/* ── Upload progress components ── */

export const LocalPreviewWrap = styled.div`
    position: relative;
    margin-top: 8px;
    max-width: 260px;
    border-radius: 10px;
    overflow: hidden;
`;

export const LocalPreviewImg = styled.img`
    display: block;
    width: 100%;
    max-height: 200px;
    object-fit: cover;
    border-radius: 10px;
`;

export const PreviewOverlay = styled.div`
    position: absolute;
    inset: 0;
    background: rgba(0, 0, 0, 0.5);
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 10px;
`;

export const CancelUploadBtn = styled.button`
    position: absolute;
    top: 6px;
    right: 6px;
    width: 24px;
    height: 24px;
    border-radius: 12px;
    background: rgba(0, 0, 0, 0.6);
    border: none;
    color: #b7bdcb;
    font-size: 14px;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;

    &:active {
        background: rgba(0, 0, 0, 0.8);
    }
`;

export const FileUploadProgressTrack = styled.div`
    height: 3px;
    background: #2b2d33;
    border-radius: 999px;
    overflow: hidden;
    margin-top: 4px;
`;

export const FileUploadProgressFill = styled.div<{ progress: number }>`
    height: 100%;
    width: ${(p) => p.progress}%;
    background: #5e84ed;
    border-radius: 999px;
    transition: width 0.2s ease-out;
`;

export const UploadProgressPill = styled.span`
    font-family: Inter, system-ui, -apple-system, Segoe UI, Roboto, sans-serif;
    font-size: 11px;
    color: #b7bdcb;
    font-weight: 500;
    margin-left: 4px;
`;

export const RetryTap = styled.span`
    color: #ff6b6b;
    font-size: 12px;
    cursor: pointer;

    &:active {
        opacity: 0.7;
    }
`;

export const SentCheck = styled.span`
    color: #5e84ed;
    font-size: 12px;
`;

export const TranscribingIndicator = styled.div`
    display: flex;
    align-items: center;
    gap: 6px;
    font-size: 12px;
    color: #8f95a3;
    margin-top: 4px;
`;
